$(document).ready(function() {
  // bind click event to all internal page anchors
  $("a[href*=\\#]").bind("click", function(e) {
  // prevent default action and bubbling
    // e.preventDefault();
    e.stopPropagation();
    // set target to anchor's "href" attribute
    var target = $(this).attr("href");
    // scroll to each target
    $(target).velocity("scroll", {
      duration: 500,
      offset: -20,
      easing: "ease-in-out"
    });
  });
});

// Aside Navigation Slide Out

var asideNav = true;

$('.hamburger').click(function(){
  if(asideNav == true){
    $('.aside').velocity({translateX: '-200px'}, { duration: 500, easing: 'easeOutQuint'});
    setTimeout(function(){ asideNav = false; }, 500);
  } else {
    $('.aside').velocity({translateX: '0px'}, { duration: 500, easing: 'easeOutQuint'});
    asideNav = true;
  }
});

$('.aside').click(function(e){
	if(e.target.className != 'click-slider-buttons'){
  	if(asideNav == false){
    	$('.aside').velocity({translateX: '0px'}, { duration: 500, easing: 'easeOutQuint'});
    	asideNav = true;
  	}
  }
});

// Main Navigation Hover

var linkWidth = $('.active').width() + 4;
$('.active').children('span').css({'opacity': '1', 'width': linkWidth, 'bottom': '0'});

$('a#nav-link').hover(function(){
  if($(this).children('li').hasClass("active")){} else {
  var linkWidth = $(this).children('li').width() + 4;
  $(this).children('li').children('span').css({"width": linkWidth});
  $(this).children('li').children('span').show();
  $(this).children('li').children('span').stop().velocity({ bottom: '0', opacity: '1' }, {duration: 400, easing: 'easeOutQuint'});
  }
}, function(){
  if($(this).children('li').hasClass("active")){} else {
  $(this).children('li').children('span').stop().velocity({ bottom: '-10px', opacity: '0' }, {duration: 400, easing: 'easeOutQuint'});
  $(this).children('li').children('span').hide()
  }
});

// Slider Navigation Hover
if($('html').scroll() == true){

}else{
  $('.active-slide').children('span').css({'opacity': '1'});

  $('.slide-nav').hover(function(){
    if($(this).hasClass("active-slide")){} else {
    $(this).children('span').stop().velocity('transition.slideRightIn', {duration: 300, easing: 'easeOutQuint'});
    }
  }, function(){
    if($(this).hasClass("active-slide")){} else {
    $(this).children('span').velocity('transition.slideLeftOut', {duration: 300, easing: 'easeOutQuint'});
    }
  });
}

// What Is Video Hover
if($('html').scroll() == true){

}else{
  $('div.video').hover(function(){
    $('#video-play').stop().velocity({ backgroundColorAlpha: '.7' }, { duration: 200 })
    $('#video-play').children('div').stop().velocity('transition.slideUpIn', { duration: 400, stagger: 100, easing: 'easeOutQuint' });
  }, function(){
    $('#video-play').velocity({ backgroundColorAlpha: '0' }, { duration: 200, delay: 300 })
    $('#video-play').children('div').velocity('transition.slideDownOut', { duration: 400, easing: 'easeOutQuint' });
  });
}

// Icon Area Hovers
if($('html').scroll() == true){

}else{
  $('.icon-area').hover(function(){
    //$(this).stop().velocity({ opacity: '.8' }, { duration: 300, easing: 'easeOutQuint' });
    $(this).stop().velocity({ scale: '1.05' }, { duration: 300, easing: 'easeOutQuint' })
  }, function(){
    //$(this).stop().velocity({ opacity: '1' }, { duration: 300, easing: 'easeOutQuint' });
    $(this).velocity({ scale: '1' }, { duration: 300, easing: 'easeOutQuint' })
  });
}

// Try It Out Hover

$('.try-it-out').hover(function(){
  $(this).stop().velocity({ width: '225px' }, { duration: 400, easing: 'easeOutQuint' });
  $(this).children().stop().velocity( 'transition.slideLeftIn', { duration: 400, delay: 100, easing: 'easeOutQuint' });
}, function(){
  $(this).velocity({ width: '195px' }, { duration: 400, delay: 200, easing: 'easeOutQuint' });
  $(this).children().velocity({ opacity: 0 }, { duration: 400, easing: 'easeOutQuint' });
});

// Try It Top

// $('#free-trial').hover(function(){
//   $(this).children('div').velocity({ left: '160px' }, { duration: 400, easing: 'easeOutQuint' });
//   $(this).children('span').velocity({ translateX: '130px' }, { duration: 400, easing: 'easeOutQuint' });
// }, function(){

// });

// Sign In and Sign Up Hover

// $('#sign-in').hover(function(){
//   $('#sign-in').stop().velocity({ backgroundColor: '#eee' }, { duration:  400, easing: 'easeOutQuint'});
// }, function(){
//   $('#sign-in').velocity({ backgroundColor: '#ddd' }, { duration:  400, easing: 'easeOutQuint'});
// });
// $('#sign-up').hover(function(){
//   $('#sign-up').stop().velocity({ backgroundColor: '#eee' }, { duration:  400, easing: 'easeOutQuint'});
// }, function(){
//   $('#sign-up').velocity({ backgroundColor: '#ddd' }, { duration:  400, easing: 'easeOutQuint'});
// });

// Social Hover

$('.social').children('a').hover(function(){
  $(this).children('img').stop().velocity({ opacity: '1' }, { duration: 300, easing: 'easeOutQuint'});
}, function(){
  $(this).children('img').velocity({ opacity: '0.6' }, { duration: 300, easing: 'easeOutQuint'});
});

// Site Map Hover

$('#site-map').children('a').hover(function(){
  $(this).children('li').stop().velocity({ color: '#ccc' }, { duration: 300, easing: 'easeOutQuint'});
}, function(){
  $(this).children('li').velocity({ color: '#888' }, { duration: 300, easing: 'easeOutQuint'});
});
